import './PolicyPages.css';

const PrivacyPolicy = () => {
  return (
    <div className="policy-container" data-testid="privacy-policy">
      <div className="policy-header">
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-subtitle">Last Updated: January 2025</p>
      </div>

      <div className="policy-content">
        <section className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>
            Mediawise Solutions collects personal information that you provide to us when you:
          </p>
          <ul>
            <li>Complete our Wise Check diagnostic questionnaire</li>
            <li>Book a strategy session</li>
            <li>Contact us via email or phone</li>
            <li>Use our website</li>
          </ul>
          <p>
            This information may include your name, email address, phone number, business name, and responses to diagnostic questions about your business operations.
          </p>
        </section>

        <section className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide personalized business consulting and strategy services</li>
            <li>Analyze your business constraints and prepare diagnostic reports</li>
            <li>Communicate with you about our services</li>
            <li>Schedule and conduct strategy sessions</li>
            <li>Improve our services and website</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or rent your personal information to third parties. Your Wise Check results and business information are kept confidential and are only shared with you and our consulting team.
          </p>
        </section>

        <section className="policy-section">
          <h2>4. Data Security</h2>
          <p>
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. All data is stored securely and transmitted using encrypted connections.
          </p>
        </section>

        <section className="policy-section">
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal information</li>
            <li>Request correction of your information</li>
            <li>Request deletion of your information</li>
            <li>Opt-out of marketing communications</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>6. Contact Us</h2>
          <p>
            If you have questions about this Privacy Policy or wish to exercise your rights, please contact us:
          </p>
          <p className="contact-info">
            <strong>Email:</strong> mitch@mediawisesolutions.com.au<br />
            <strong>Phone:</strong> 0409 265 711
          </p>
        </section>
      </div>

      <div className="policy-footer">
        <a href="/" className="back-link">← Back to Home</a>
      </div>
    </div>
  );
};

export default PrivacyPolicy;